// The site's structural signature: section breaks use a torn banana-leaf
// edge instead of a straight line or a generic wave. `tone` sets the fill
// (the color of the section this divider visually belongs to); `flip`
// alternates the silhouette so consecutive dividers don't repeat identically.
const LeafDivider = ({ tone = "var(--baale-green)", flip = false, className = "" }) => (
  <div
    className={`leaf-divider ${className}`}
    aria-hidden="true"
    style={{
      lineHeight: 0,
      transform: flip ? "scaleX(-1)" : undefined,
    }}
  >
    <svg
      viewBox="0 0 1440 64"
      preserveAspectRatio="none"
      style={{ width: "100%", height: "clamp(26px, 5vw, 56px)", display: "block" }}
    >
      <path
        fill={tone}
        d="M0,0 L0,18 C70,42 150,4 230,24 C300,42 360,10 430,26
           C500,44 560,8 630,22 C700,40 770,6 840,24
           C910,42 970,10 1040,24 C1110,42 1180,8 1250,22
           C1320,40 1380,10 1440,20 L1440,0 Z"
      />
    </svg>
  </div>
);

export default LeafDivider;
